module.exports = __webpack_public_path__ + "52a8e0c5f4e948e4fce6c129879a6f59.MP3";